import React, { useEffect } from "react";
import { InvitationView } from "./view";
import { useLocation, useParams } from "react-router";
import { useDispatch, useSelector } from "react-redux";
import {
  getInvitationDataSelector,
  isInvitaionDataLoading,
} from "features/friend-refer/redux/selectors";
import { fetchInvitation } from "features/friend-refer/redux/actions";
import queryString from "query-string";
import { incrementReferral } from "../../../home/requests/increment-referral";
import ReferralHash from "../../../../common/referral-hash";

export const Invitation = () => {
  const { hash } = useParams();
  const dispatch = useDispatch();
  const invitationData = useSelector(getInvitationDataSelector);
  const isLoading = useSelector(isInvitaionDataLoading);
  const location = useLocation();

  useEffect(() => {
    dispatch(fetchInvitation(hash));

    let referralHash = null;

    if (location.search) {
      referralHash = queryString.parse(location.search.replace("+", "%2B"))
        .referral_hash;

      if (referralHash) {
        localStorage.setItem("referral_hash", referralHash);
        incrementReferral(referralHash);
      }
    }

    if (!referralHash) {
      referralHash = localStorage.getItem("referral_hash");
    }

    ReferralHash.hash = referralHash;
  }, []);

  return <InvitationView isLoading={isLoading} data={invitationData} />;
};
